import { Injectable } from '@angular/core';
import { PeriodoSorteioMensalAtual } from '../../../shared/model/periodo-sorteio-atual.model';
import { SorteioService } from './sorteio.service';

@Injectable()
export class SessionStorageSorteio {

  constructor(private readonly sorteioService: SorteioService) {}

  // Tem como principal função evitar que a obtenção da informação obtida dinamicamente gere problemas de carregamento
  // Em telas que necessitem da informação como o Histórico de Bilhetes.
  public DefinirSessionStoragePeriodoSorteioMensalAtual() {

    // Por podrão, retorno apenas o do mensal.
    this.sorteioService.getPeriodoSorteioAtual().subscribe(
      (data: PeriodoSorteioMensalAtual) => {

        if(data){

          sessionStorage.setItem('ano_sorteio_mensal_atual', data.ano_sorteio_atual.toString());
          sessionStorage.setItem('mes_sorteio_mensal_atual', data.mes_sorteio_atual.toString());

        }else{

          this.definirAnoMesPadraoInicialSorteio();
        }

      },
      (error: any) => {
         this.definirAnoMesPadraoInicialSorteio();
      },
    );
  }

  private definirAnoMesPadraoInicialSorteio(){

   // Em caso de erro, respeita a lógica antiga para não gerar problema na tela.
   const hoje = new Date();
   sessionStorage.setItem('ano_sorteio_mensal_atual', hoje.getFullYear().toString());
   sessionStorage.setItem('mes_sorteio_mensal_atual', (hoje.getMonth() + 1).toString());

  }


}



// WEBPACK FOOTER //
// ./src/app/publico/sorteios/shared/session-storage-sorteio.ts